import extractErrorMessage from '../utils/extractErrorMessage';
import { publicClient } from './client';

export const AuthAPI = {
  login: async ({ email, password }) => {
    try {
      const response = await publicClient.post('auth/login', {
        email,
        password,
      });
      return response.data;
    } catch (error) {
      console.error('Error during login:', error);
      const message = extractErrorMessage(
        error,
        'Došlo je do greške pri prijavi.'
      );
      return { data: null, success: false, message: message };
    }
  },

  resetPassword: async ({ password, passwordToken, lang }) => {
    try {
      const response = await publicClient.put(
        `auth/reset-password/${encodeURIComponent(passwordToken)}`,
        { password },
        { headers: { 'Accept-Language': lang || 'sr' } }
      );
      return response.data;
    } catch (error) {
      console.error('Error during reset password:', error);
      const message = extractErrorMessage(
        error,
        'Došlo je do greške pri promeni lozinke.'
      );
      return { data: null, success: false, message: message };
    }
  },

  // Checks the emailed reset link before the form is shown; does not use up the token.
  validateResetToken: async ({ token, lang }) => {
    try {
      const response = await publicClient.get(
        `auth/reset-password/${encodeURIComponent(token)}`,
        { headers: { 'Accept-Language': lang || 'sr' } }
      );
      return response.data;
    } catch (error) {
      console.error('Error validating reset token:', error);
      const message = extractErrorMessage(
        error,
        'Link za promenu šifre je nevažeći ili je istekao.'
      );
      return { data: null, success: false, message: message };
    }
  },

  forgotPassword: async ({ email }) => {
    try {
      const response = await publicClient.post(
        'auth/forgot-password',
        { email },
        { headers: { 'Accept-Language': 'sr' } }
      );
      return response.data;
    } catch (error) {
      console.error('Error during forgot password:', error);
      const message = extractErrorMessage(
        error,
        'Došlo je do greške pri slanju email-a za restartovanje lozinke.'
      );
      return { data: null, success: false, message: message };
    }
  },
};
